/* eslint-disable no-restricted-syntax */
import { api } from "src/utils/api";

const list = async params => {
    const result = await api.get("/requests", {
        params
    });

    return result;
};

const text = async (id, text) => {
    const result = await api.post(`/requests/create-interaction/${id}`, { text })
    return result;
};

const upload = async (id, files) => {
    const formData = new FormData();

    for(const file of files) {
        formData.append('files[]', file);
    }

    const result = await api.post(`/requests/upload/${id}`, formData);
    return result;
};

const loadRequest = id => api.get(`/requests/${id}`);

export { list, loadRequest, text, upload };
